export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-graph-bar-fba197ae0d864654e66094c7a74c1335.svg";